module.exports = __webpack_public_path__ + "img/abstract-lines.650c0e59.svg";